var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> Отправка заявки проверки КБМ доступна только для авторизованных пользователей. Пожалуйста войдите в <a data-bind="attr: { href: Misc.myRgsHomeUrl() }">личный кабинет</a> </div>';
}
return __p;
};
